class DisplayUtilityClass {
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor,@typescript-eslint/no-empty-function
  constructor() {}

  // eslint-disable-next-line func-names,class-methods-use-this
  formatNumberThreeDigits = function (value: number | string): string {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  // @ts-ignore
  formatPriceTenThousandYen(value: number): string {
    // 数値を小数点未満で切り上げ・切り捨てを行い３桁区切りを適用する
    const num = parseFloat(value.toString().replace(/,/g, '')) / 10000;
    const roundedNum = Math.round(num);
    return `${this.formatNumberThreeDigits(roundedNum)}万円`;
  }

  // @ts-ignore
  // formatPriceTenThousandYenのメソッドでは小数点第一位が表示されない為、小数点表示用のメソッド
  formatPriceTenThousandYenFirstDecimal(value: number): string {
    // 数値を小数点未満で切り上げ・切り捨てを行い３桁区切りを適用する
    const num = parseFloat(value.toString().replace(/,/g, '')) / 10000;
    const roundedNum = Math.round(num * 10) / 10; // 小数点第一位まで四捨五入する
    const formattedNum = roundedNum.toFixed(1); // 小数点第一まで表示
    return `${this.formatNumberThreeDigits(formattedNum)}万円`;
  }

  // eslint-disable-next-line class-methods-use-this
  formatDate(value: string): string {
    const date = new Date(value);
    const year = date.getFullYear();
    const month = date.getMonth() + 1; // getMonth()は0から始まるため+1する
    return `${year}年${month}月`;
  }

  // RatingのdefaultValueに設定する際に使用(数値で返す)
  // eslint-disable-next-line class-methods-use-this
  formatDecimalDigitToNumber(value: number | boolean): number {
    if (typeof value === 'number') {
      return value;
    }
    return 0;
  }

  // Ratingのスコアをテキスト表示する際に使用(文字列で返す)
  // eslint-disable-next-line class-methods-use-this
  formatDecimalDigitToString(value: number | boolean): string {
    if (typeof value === 'number') {
      return value.toFixed(1);
    }
    return '0';
  }
}

const DisplayUtility = new DisplayUtilityClass();
export default DisplayUtility;
